import { useNavigate } from "react-router";

import RoleplayList from "@/../../hypetrain/static/img/exec/roleplay-block.png";

import { HomeBlock } from "./HomeBlock";

export function RoleplayBlock() {
  const navigate = useNavigate();

  const renderContent = () => {
    return (
      <div className="xs:p-5 md:min-h-50 md:p-6">
        <div className="overflow-hidden border-b-1 px-4 grayscale group-hover:grayscale-0">
          <div className="group-hover:text-foreground text-sm font-semibold text-gray-600">
            AI Roleplay Scenarios
          </div>
          <div className="relative h-full">
            <img
              className="w-full translate-y-[4.5%] transition-all duration-300 ease-out group-hover:translate-y-0"
              src={RoleplayList}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <HomeBlock
      key="roleplay-home-block"
      title="AI Roleplays"
      description="Practice your skills in AI-powered scenarios."
      content={renderContent()}
      isEmpty={true}
      onClick={() => {
        navigate("/roleplays");
      }}
    />
  );
}
